import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AdminComponent } from "./admin/admin.component";
import { AdminModuleGuard } from "./admin/guards/admin-module-guard.guard";

const routes: Routes = [
  {
    path: "",
    loadChildren: () =>
      import("./website/website.module").then(m => m.WebsiteModule)
  },
  {
    path: "onboarding",
    loadChildren: () => import('./onboarding/onboarding.module')
         .then(m => m.OnboardingModule)
  },
  {
    path: "admin",
  //  component: AdminComponent,  
  canLoad: [AdminModuleGuard],
     canActivate: [AdminModuleGuard],loadChildren: () => import("./admin/admin.module").then(m => m.AdminModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
